import {useEffect, useState} from 'react';
import {Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Card, Form, Input, Layout, Space, Spin, Typography} from 'antd';
import {Route} from 'react-router-dom';

import {getCurrentUserPermission} from '../utils';
import {SchoolEdit} from '../modules/Schools/SchoolEdit';
import {ClassSchoolDetails} from '../modules/Schools/ClassSchoolDetails';
import {SchoolsTable} from '../modules/Schools/SchoolsTable';
import {SiderComponent} from './';
import {
  EnrollmentsTable,
  EnrollmentDetails,
  EnrollmentCreate,
  EnrollmentEdit,
  StudentDetails,
  StudentsTable,
  TestDetails,
  TestsTable,
  Dashboard,
  PlanDetails,
  PlanEdit,
  TestCreate,
  PackagesTable,
  PackageDetails,
  PackageEdit,
  PackageCreate,
  PriceCreate,
  PriceEdit,
  PricesTable,
  StudentEdit,
  ProgramsTable,
  ProgramEdit,
  ProgramCreate,
  LevelsTable,
  LevelCreateEdit,
  TestEdit,
  AddingRole,
  StudentSessionDetails,
  UserDetails,
  DiscountCodeTable,
  DiscountCodeDetails,
  CurriculumCreate,
  CurriculumEdit,
  CurriculumsTable,
  StudentReport,
  PlacementTestCreate,
  PlacementTestsTable,
  PlacementTestDetails,
  PlacementTestEdit,
  StoryTable,
  StoryCreate,
  StoryEdit,
  GradesTable,
  GradeCreateEdit,
  PlanPreviewPage,
  DailyExercisesReviewTable,
} from '../modules';
import {doForgotPassword, doSignIn} from '../redux/actions/user';
import {DiscountCodeForPartnerTable} from '../modules/DiscountCodeForPartner';
import {DiscountCodeForPartnerDetails} from '../modules/DiscountCodeForPartner/DiscountCodeForPartnerDetails';
import {SchoolCreate} from '../modules/Schools/SchoolCreate';
import {PlanTableContainer} from '../modules/Plans/PlanTableContainer';
import {PlanCreate} from '../modules/Plans/PlanCreate';

const {Content} = Layout;
const {Title} = Typography;

export const Routers = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: any) => state.user.isLoggedIn);

  const isLoading = useSelector((state: any) => state.user?.isLoading);

  const [currentUserPermission, setCurrentUserPermission] = useState<any>();
  const [isForgotPasswordMode, setIsForgotPasswordMode] = useState(false);
  const renderPartnersRoutes = () => {
    return (
      <>
        <Route exact path="/partners">
          <DiscountCodeForPartnerTable />
        </Route>
        <Route path="/discount-code-details">
          <DiscountCodeForPartnerDetails />
        </Route>
      </>
    );
  };

  const renderEditorsRoutes = () => {
    return (
      <>
        {/** Enrollments routes*/}
        <Switch>
          <Route exact path="/enrollments">
            <EnrollmentsTable />
          </Route>
          <Route path="/enrollments/create">
            <EnrollmentCreate />
          </Route>
          <Route exact path="/enrollments/:enrollmentId">
            <EnrollmentDetails />
          </Route>
          <Route exact path="/enrollments/:enrollmentId/edit">
            <EnrollmentEdit />
          </Route>
        </Switch>
        <Route exact path="/school/:schoolId/edit">
          <SchoolEdit />
        </Route>
        <Route exact path="/class-schools/:classSchoolId">
          <ClassSchoolDetails />
        </Route>

        {/** Students routes*/}
        <Route exact path="/students">
          <StudentsTable />
        </Route>
        <Route exact path="/students/:studentId">
          <StudentDetails />
        </Route>
        <Route exact path="/students/:studentId/edit">
          <StudentEdit />
        </Route>
        <Route exact path="/student-sessions/:studentId">
          <StudentSessionDetails />
        </Route>
        <Route exact path="/students/:studentId/report/:statisticId">
          <StudentReport />
        </Route>

        {/** DiscountCodes routes*/}
        <Route exact path="/discountcodes">
          <DiscountCodeTable />
        </Route>
        <Route exact path="/discountcodes/:codeId">
          <DiscountCodeDetails />
        </Route>
        {/** user routes*/}
        <Route path="/users/:userId">
          <UserDetails />
        </Route>
      </>
    );
  };

  const renderContentCreatorRoutes = () => (
    <Switch>
      <Route exact path="/tests">
        <TestsTable />
      </Route>
      <Route exact path="/tests/create">
        <TestCreate />
      </Route>
      <Route path="/tests/:testId">
        <TestDetails />
      </Route>
      <Route path="/test/:testId/edit">
        <TestEdit />
      </Route>
      <Route exact path="/daily-exercises-review">
        <DailyExercisesReviewTable />
      </Route>
    </Switch>
  );
  const renderAdminRoutes = () => (
    <>
      {/** Plans routes*/}
      <Switch>
        <Route exact path="/plans">
          <PlanTableContainer />
        </Route>
        <Route exact path="/plans/create">
          <PlanCreate />
        </Route>
        <Route exact path="/plans/:planId">
          <PlanDetails />
        </Route>
        <Route exact path="/plans/:planId/edit">
          <PlanEdit />
        </Route>
      </Switch>
      {/** Tests routes*/}
      <Switch>
        <Route exact path="/tests">
          <TestsTable />
        </Route>
        <Route exact path="/tests/create">
          <TestCreate />
        </Route>
        <Route path="/tests/:testId">
          <TestDetails />
        </Route>
        <Route path="/test/:testId/edit">
          <TestEdit />
        </Route>
      </Switch>
      {/** Daily Exercises Review route*/}
      <Route exact path="/daily-exercises-review">
        <DailyExercisesReviewTable />
      </Route>
      {/** Plan Preview route*/}
      <Route exact path="/plan-preview">
        <PlanPreviewPage />
      </Route>
      {/** Placement Tests routes*/}
      <Switch>
        <Route exact path="/placement-tests">
          <PlacementTestsTable />
        </Route>
        <Route exact path="/placement-tests/create">
          <PlacementTestCreate />
        </Route>
        <Route path="/placement-tests/:placementTestId/edit">
          <PlacementTestEdit />
        </Route>
        <Route path="/placement-tests/:testId">
          <PlacementTestDetails />
        </Route>
      </Switch>
      {/** Packages routes*/}
      <Route exact path="/packages">
        <PackagesTable />
      </Route>
      <Route path="/package/create">
        <PackageCreate />
      </Route>
      <Route exact path="/packages/:packageId">
        <PackageDetails />
      </Route>
      <Route path="/packages/:packageId/edit">
        <PackageEdit />
      </Route>
      {/** Packages routes*/}
      {/** Prices routes*/}
      <Route exact path="/prices">
        <PricesTable />
      </Route>
      <Route path="/prices/create">
        <PriceCreate />
      </Route>
      <Route exact path="/prices/:priceId/edit">
        <PriceEdit />
      </Route>

      {/** Program routes*/}
      <Route exact path="/programs">
        <ProgramsTable />
      </Route>
      <Route path="/programs/create">
        <ProgramCreate />
      </Route>
      <Route exact path="/programs/:programId/edit">
        <ProgramEdit />
      </Route>

      {/** Levels routes*/}
      <Route exact path="/levels">
        <LevelsTable />
      </Route>
      <Route path="/levels/create">
        <LevelCreateEdit />
      </Route>
      <Route exact path="/levels/:levelId/edit">
        <LevelCreateEdit />
      </Route>

      {/** Grades routes*/}
      <Route exact path="/grades">
        <GradesTable />
      </Route>
      <Route path="/grades/create">
        <GradeCreateEdit />
      </Route>
      <Route exact path="/grades/:gradeId/edit">
        <GradeCreateEdit />
      </Route>

      {/** schools routes*/}
      <Route exact path="/schools">
        <SchoolsTable />
      </Route>
      <Route path="/schools/create">
        <SchoolCreate />
      </Route>

      {/** accounts routes*/}
      <Route path="/accounts/role">
        <AddingRole />
      </Route>

      {/** Curriculums routes*/}
      <Route exact path="/curriculums">
        <CurriculumsTable />
      </Route>

      <Route path="/curriculums/create">
        <CurriculumCreate />
      </Route>
      <Route exact path="/curriculums/:curriculumId/edit">
        <CurriculumEdit />
      </Route>

      {/** Story routes */}
      <Switch>
        <Route exact path="/stories">
          <StoryTable />
        </Route>
        <Route exact path="/stories/create">
          <StoryCreate />
        </Route>
        <Route exact path="/stories/:storyId">
          <StoryEdit />
        </Route>
        <Route exact path="/stories/:storyId/edit">
          <StoryEdit />
        </Route>
      </Switch>
    </>
  );

  useEffect(() => {
    if (!isLoggedIn) {
      setCurrentUserPermission(undefined);
      return;
    }

    getCurrentUserPermission()
      .then((p: any) => {
        setCurrentUserPermission(() => p);
        console.log('isLoggedIn000', p);
      })
      .catch(er => {
        console.log('err->', er);
        setCurrentUserPermission(undefined);
      });
  }, [isLoggedIn]);
  console.log('currentUserPermission', currentUserPermission);
  return (
    <div
      style={{
        flex: 1,
        justifyContent: 'center',
      }}>
      {!isLoggedIn && !isLoading ? (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}>
          <Card style={{width: 380, maxWidth: 'calc(100vw - 32px)'}}>
            <Title level={3} style={{marginBottom: 24, textAlign: 'center'}}>
              {isForgotPasswordMode ? 'Reset Password' : 'Admin Login'}
            </Title>
            {isForgotPasswordMode ? (
              <Form
                layout="vertical"
                requiredMark={false}
                onFinish={({email}) => {
                  dispatch(doForgotPassword(email) as any);
                }}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {required: true, message: 'Please enter your email'},
                    {type: 'email', message: 'Please enter a valid email'},
                  ]}>
                  <Input autoComplete="email" size="large" />
                </Form.Item>
                <Button
                  block
                  htmlType="submit"
                  loading={isLoading}
                  size="large"
                  type="primary">
                  Send reset link
                </Button>
                <Button
                  block
                  onClick={() => setIsForgotPasswordMode(false)}
                  size="large"
                  style={{marginTop: 8}}
                  type="link">
                  Back to sign in
                </Button>
              </Form>
            ) : (
              <Form
                layout="vertical"
                requiredMark={false}
                onFinish={({email, password}) => {
                  dispatch(doSignIn(email, password));
                }}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {required: true, message: 'Please enter your email'},
                    {type: 'email', message: 'Please enter a valid email'},
                  ]}>
                  <Input autoComplete="email" size="large" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {required: true, message: 'Please enter your password'},
                  ]}>
                  <Input.Password
                    autoComplete="current-password"
                    size="large"
                  />
                </Form.Item>
                <Button
                  block
                  htmlType="submit"
                  loading={isLoading}
                  size="large"
                  type="primary">
                  Sign in
                </Button>
                <Button
                  block
                  onClick={() => setIsForgotPasswordMode(true)}
                  size="large"
                  style={{marginTop: 8}}
                  type="link">
                  Forgot password?
                </Button>
              </Form>
            )}
          </Card>
        </div>
      ) : (
        currentUserPermission && (
          <>
            <Content>
              <SiderComponent />
              <Route exact path="/">
                <Dashboard />
              </Route>
              {(currentUserPermission === 'editor' ||
                currentUserPermission === 'admin') &&
                renderEditorsRoutes()}
              {currentUserPermission === 'admin' && renderAdminRoutes()}

              {currentUserPermission === 'partner' && renderPartnersRoutes()}
              {currentUserPermission === 'CONTENT_CREATOR' &&
                renderContentCreatorRoutes()}
            </Content>
          </>
        )
      )}

      {isLoading && (
        <Space
          direction="vertical"
          style={{
            width: '100%',
            top: '50%',
            backgroundColor: 'red',
            position: 'absolute',
          }}>
          <Spin tip="Loading">
            <div className="content" />
          </Spin>
        </Space>
      )}
    </div>
  );
};
